package org.zest.insan_360_website.pages.user.main_layout

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.rememberCoroutineScope
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Height
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.UserSelect
import kotlinx.coroutines.CoroutineScope
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.forms.Input
import com.varabyte.kobweb.silk.components.icons.fa.*
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text
import org.zest.insan_360_website.components.layouts.*
import org.zest.insan_360_website.components.widgets.*
import org.zest.insan_360_website.data.LanguageSettings
import org.zest.insan_360_website.data.localized
import org.zest.insan_360_website.data.page_states.AuthState
import org.zest.insan_360_website.data.page_states.MaintenanceState
import org.zest.insan_360_website.data.page_states.dashboard.MainDashPageState.grantState
import org.zest.insan_360_website.data.page_states.dashboard.MainDashPageState.handleGrantCredit
import org.zest.insan_360_website.data.page_states.dashboard.MainDashPageState.supAdmDataStats
import org.zest.insan_360_website.model.UserRole

data class GrantState(
    val email: String = "",
    val count: Int = 0,
    val isProcessing: Boolean = false,
) {
    companion object {
        private val EMAIL_REGEX = Regex("^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+\\.[a-zA-Z]+$")
    }

    fun validate(): String? {
        val sanitizedEmail = email.trim()
        if (sanitizedEmail.isBlank()) return userDashWordLibrary.please_enter_user_email.localized
        if (count <= 0) return userDashWordLibrary.credit_more_than_0.localized
        if (!sanitizedEmail.matches(EMAIL_REGEX)) return userDashWordLibrary.valid_email.localized
        return null
    }
}

val supAdmMainDashContentLayout = CssStyle {
    base {
        Modifier
            .grid {
                columns { repeat(2) { size(1.fr) } }
                rows { repeat(3) { size(1.fr) } }
            }
    }
    Breakpoint.XL {
        Modifier
            .grid {
                columns { repeat(3) { size(1.fr) } }
                rows { repeat(2) { size(1.fr) } }
            }
    }
}

@Composable
fun SuperAdminLayout() {
    val modal = LocalModal.current
    val pageScope = rememberCoroutineScope()

    LaunchedEffect(Unit) {
        MaintenanceState.fetchMaintenanceStatus(pageScope)
    }

    PageContentBaseCol(Modifier.userSelect(UserSelect.None)) {
        Div(
            supAdmMainDashContentLayout.toModifier()
                .fillMaxWidth()
                .gap(1.cssRem)
                .toAttrs()
        ) {
            StatContainer(
                userDashWordLibrary.total_user.localized,

                supAdmDataStats?.totalStud.toString()
            ) { FaUser(size = IconSize.LG, style = IconStyle.FILLED) }
            StatContainer(
                userDashWordLibrary.test_taken.localized,
                supAdmDataStats?.totalTestSub.toString()
            ) { FaWpforms(size = IconSize.LG) }
            StatContainer(
                userDashWordLibrary.test_need_verify.localized,
                supAdmDataStats?.totalNeedVerify.toString()
            ) { FaListCheck(size = IconSize.LG) }
            StatContainer(
                userDashWordLibrary.admin_need_verify.localized,
                supAdmDataStats?.adminNeedVerify.toString()
            ) { FaUserCheck(size = IconSize.LG) }
            StatContainer(
                userDashWordLibrary.total_admin_org.localized,
                supAdmDataStats?.totalAdmin.toString()
            ) { FaBuildingUser(size = IconSize.LG) }

            PageContentContainer(
                Modifier
                    .padding(1.cssRem)
                    .then(containerShadowStyle.toModifier())
            ) {
                Column(
                    Modifier
                        .fillMaxSize()
                        .justifyContent(JustifyContent.SpaceBetween)
                        .gap(1.cssRem)
                ) {
                    Row(
                        Modifier
                            .fillMaxWidth()
                            .gap(0.5.cssRem),
                        verticalAlignment = Alignment.CenterVertically,
                    ) {
                        Box(
                            Modifier
                                .height(2.75.cssRem)
                                .aspectRatio(1f)
                                .backgroundColor(userPageBGColor)
                                .borderRadius(0.75.cssRem)
                                .border {
                                    color(userPageBorderStrongColor)
                                    width(1.px)
                                    style(LineStyle.Solid)
                                },
                            contentAlignment = Alignment.Center
                        ) {
                            FaHandsHoldingCircle(size = IconSize.LG)
                        }
                        SpanText(
                            userDashWordLibrary.give_credit_to_user.localized,
                            Modifier
                                .fontSize(1.cssRem)
                                .fontWeight(FontWeight.Bold)
                                .color(userPageSecondaryTextColor)
                        )
                    }
                    Box(
                        contentButtonStyle.toModifier()
                            .fillMaxWidth()
                            .onClick {
                                modal.show { giveCreditModal() }
                            },
                        contentAlignment = Alignment.Center
                    ) {
                        SpanText(
                            userDashWordLibrary.give_credit.localized,
                            contentButtonTextStyle.toModifier()
                        )
                    }
                }
            }
            PageContentContainer(
                Modifier
                    .padding(1.cssRem)
                    .then(containerShadowStyle.toModifier())
            ) {
                Column(
                    Modifier
                        .fillMaxSize()
                        .justifyContent(JustifyContent.SpaceBetween)
                        .gap(1.cssRem)
                ) {
                    Row(
                        Modifier
                            .fillMaxWidth()
                            .gap(0.5.cssRem),
                        verticalAlignment = Alignment.CenterVertically,
                    ) {
                        Box(
                            Modifier
                                .height(2.75.cssRem)
                                .aspectRatio(1f)
                                .backgroundColor(userPageBGColor)
                                .borderRadius(0.75.cssRem)
                                .border {
                                    color(userPageBorderStrongColor)
                                    width(1.px)
                                    style(LineStyle.Solid)
                                },
                            contentAlignment = Alignment.Center
                        ) {
                            FaGear(size = IconSize.LG)
                        }
                        SpanText(
                            LanguageSettings.Maintenance.mode_title.localized, //LANGUAGE: set
                            Modifier
                                .fontSize(1.cssRem)
                                .fontWeight(FontWeight.Bold)
                                .color(userPageSecondaryTextColor)
                        )
                    }
                    Row(
                        Modifier.fillMaxWidth().gap(0.5.cssRem),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Box(
                            Modifier
                                .size(0.625.cssRem)
                                .borderRadius(50.percent)
                                .backgroundColor(
                                    if (MaintenanceState.isMaintenanceMode)
                                        rgb(239, 68, 68)  // red-500
                                    else
                                        rgb(34, 197, 94)  // green-500
                                )
                        )
                        SpanText(
                            if (MaintenanceState.isMaintenanceMode) LanguageSettings.Maintenance.on_status.localized else LanguageSettings.Maintenance.off_status.localized,
                            Modifier
                                .fontSize(0.875.cssRem)
                                .fontWeight(FontWeight.Bold)
                                .color(userPagePrimaryTextColor)
                        )
                        SpanText(
                            if (MaintenanceState.isMaintenanceMode) LanguageSettings.Maintenance.on_desc.localized else LanguageSettings.Maintenance.off_desc.localized,
                            Modifier
                                .fontSize(0.875.cssRem)
                                .fontWeight(FontWeight.Medium)
                                .color(userPageSecondaryTextColor)
                        )
                    }
                    Box(
                        contentButtonStyle.toModifier()
                            .fillMaxWidth()
                            .thenIf(MaintenanceState.isLoading) { Modifier.opacity(0.5f) }
                            .onClick {
                                if (!MaintenanceState.isLoading) {
                                    modal.show { maintenanceToggleModal(pageScope) }
                                }
                            },
                        contentAlignment = Alignment.Center
                    ) {
                        SpanText(
                            if (MaintenanceState.isMaintenanceMode) LanguageSettings.Maintenance.disable.localized else LanguageSettings.Maintenance.enable.localized,
                            contentButtonTextStyle.toModifier()
                        )
                    }
                }
            }
        }
        CreditStatsContainer(
            Modifier.height(Height.FitContent),
            userDashWordLibrary.system_credit_info.localized,
            StatsSection(
                "${userDashWordLibrary.system_credit.localized} : ",
                supAdmDataStats?.creditStats?.total.toString()
            ),
            StatsSection(
                "${userDashWordLibrary.active.localized} : ",
                supAdmDataStats?.creditStats?.active.toString()
            ),
            StatsSection(
                "${userDashWordLibrary.used.localized} : ",
                supAdmDataStats?.creditStats?.used.toString()
            ),
            StatsSection(
                "${userDashWordLibrary.expired.localized} : ",
                supAdmDataStats?.creditStats?.expired.toString()
            )
        )
    }


}

@OptIn(DelicateApi::class)
@Composable
private fun giveCreditModal() {
    val toast = LocalToast.current
    val modal = LocalModal.current
    val scope = rememberCoroutineScope()
    val breakpoint = rememberBreakpoint()
    val isMobile = breakpoint < Breakpoint.SM
    val giveCreditModalLocalized = LanguageSettings.UserDashboardPage.GiveCreditModal

    Column(
        Modifier
            .fillMaxWidth()
            .padding(if (isMobile) 1.cssRem else 1.5.cssRem)
            .gap(1.5.cssRem)
            .userSelect(UserSelect.None),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        Column(
            Modifier.fillMaxWidth().gap(0.5.cssRem),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            SpanText(
                giveCreditModalLocalized.title.localized,
                Modifier
                    .fontSize(if (isMobile) 1.25.cssRem else 1.5.cssRem)
                    .fontWeight(FontWeight.Bold)
                    .color(userPagePrimaryTextColor)
                    .textAlign(TextAlign.Center)
            )
            SpanText(
                giveCreditModalLocalized.text.localized,
                Modifier
                    .fontSize(0.875.cssRem)
                    .fontWeight(FontWeight.Medium)
                    .color(userPageSecondaryTextColor)
                    .textAlign(TextAlign.Center)
            )
        }

        Input(
            modifier = Modifier
                .then(baseInputStyle.toModifier())
                .fontSize(1.5.cssRem)
                .padding(0.375.cssRem)
                .fillMaxHeight(),
            type = InputType.Email,
            value = grantState.email,
            onValueChange = { grantState = grantState.copy(email = it) },
            placeholder = authWordLibrary.email.localized
        )

        Row(
            Modifier
                .fillMaxWidth()
                .backgroundColor(userPageBGColor)
                .border {
                    width(1.px)
                    color(userPageBorderStrongColor)
                    style(LineStyle.Solid)
                }
                .borderRadius(0.5.cssRem)
                .fontSize(if (isMobile) 1.cssRem else 1.25.cssRem)
                .padding(topBottom = 1.cssRem, leftRight = 0.5.cssRem)
                .fontWeight(FontWeight.Bold)
                .color(userPagePrimaryTextColor)
                .flexWrap(FlexWrap.Wrap)
                .gap(0.5.cssRem),
            horizontalArrangement = Arrangement.Center,
            verticalAlignment = Alignment.CenterVertically
        ) {
            SpanText(giveCreditModalLocalized.grant.localized)

            Input(
                modifier = baseInputStyle.toModifier()
                    .thenIf(grantState.count < 10) { Modifier.width(if (isMobile) 2.5.cssRem else 3.125.cssRem) }
                    .thenIf(grantState.count in 10..99) { Modifier.width(if (isMobile) 3.cssRem else 3.75.cssRem) }
                    .thenIf(grantState.count >= 100) { Modifier.width(if (isMobile) 3.5.cssRem else 4.375.cssRem) }
                    .textAlign(TextAlign.Center),
                type = InputType.Number,
                value = grantState.count,
                onValueChange = { newCounter ->
                    grantState = grantState.copy(count = newCounter?.toInt()?.coerceIn(0, 100) ?: 0)
                }
            )

            SpanText(giveCreditModalLocalized.credit.localized)
        }

        Button(
            enabled = !grantState.isProcessing,
            onClick = {
                if (grantState.isProcessing) return@Button
                val message = grantState.validate()
                if (message != null) toast.show(message, ToastType.ERROR)
                else {
                    handleGrantCredit(scope, toast) {
                        modal.hide()
                    }
                }
            },
            modifier = Modifier
                .fillMaxWidth()
                .minHeight(3.cssRem)
                .fontSize(1.cssRem)
                .fontWeight(FontWeight.Bold)
        ) {
            Text(
                if (grantState.isProcessing)
                    giveCreditModalLocalized.generating_credit.localized
                else
                    "${giveCreditModalLocalized.grant.localized} ${giveCreditModalLocalized.credit.localized}"
            )
        }
    }
}

@OptIn(DelicateApi::class)
@Composable
private fun maintenanceToggleModal(pageScope: CoroutineScope) {
    val toast = LocalToast.current
    val modal = LocalModal.current
    val breakpoint = rememberBreakpoint()
    val isMobile = breakpoint < Breakpoint.SM
    val turningOn = !MaintenanceState.isMaintenanceMode

    Column(
        Modifier
            .fillMaxWidth()
            .padding(if (isMobile) 1.cssRem else 1.5.cssRem)
            .gap(1.5.cssRem)
            .userSelect(UserSelect.None),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        Column(
            Modifier.fillMaxWidth().gap(0.5.cssRem),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            SpanText(
                if (turningOn) LanguageSettings.Maintenance.enable_mode.localized
                else LanguageSettings.Maintenance.disable_mode.localized,
                Modifier
                    .fontSize(if (isMobile) 1.25.cssRem else 1.5.cssRem)
                    .fontWeight(FontWeight.Bold)
                    .color(userPagePrimaryTextColor)
                    .textAlign(TextAlign.Center)
            )
            SpanText(
                if (turningOn) LanguageSettings.Maintenance.enable_desc.localized
                else LanguageSettings.Maintenance.disable_desc.localized,
                Modifier
                    .fontSize(0.875.cssRem)
                    .fontWeight(FontWeight.Medium)
                    .color(userPageSecondaryTextColor)
                    .textAlign(TextAlign.Center)
            )
        }

        Button(
            enabled = !MaintenanceState.isLoading,
            onClick = {
                MaintenanceState.toggleMaintenance(pageScope, toast, turningOn) {
                    modal.hide()
                }
            },
            modifier = Modifier
                .fillMaxWidth()
                .minHeight(3.cssRem)
                .fontSize(1.cssRem)
                .fontWeight(FontWeight.Bold)
        ) {
            Text(
                if (turningOn) LanguageSettings.Maintenance.yes_enable.localized
            else LanguageSettings.Maintenance.yes_disable.localized
            )
        }
    }
}